import { map, orderBy } from 'lodash'
import { trans } from 'utils/helpers/translation'

export const getQuotationChargeTypes = ({ config }) => map(config.chargeTypes, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getDealQuotations = ({ all }) => orderBy(all, ['due_date_at'], ['asc'])



// WEBPACK FOOTER //
// ./src/modules/deals/components/show/quotations/store/getters.js